var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFilledCrossDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons / Outline Cross"
  }, /*#__PURE__*/React.createElement("path", {
    id: "X - Desktop",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.077 12.525C14.5056 12.9536 14.5063 13.6486 14.077 14.0779C13.6476 14.5073 12.9527 14.5065 12.5241 14.0779L7.86536 9.41924L3.20667 14.0779C2.77729 14.5073 2.08237 14.5065 1.65377 14.0779C1.22517 13.6493 1.2244 12.9544 1.65377 12.525L6.31247 7.86634L1.65377 3.20765C1.22517 2.77905 1.2244 2.08413 1.65377 1.65475C2.08315 1.22537 2.77807 1.22615 3.20667 1.65475L7.86536 6.31344L12.5241 1.65475C12.9534 1.22537 13.6484 1.22615 14.077 1.65475C14.5056 2.08335 14.5063 2.77827 14.077 3.20765L9.41826 7.86634L14.077 12.525Z",
    fill: "#393D41"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilledCrossDark);
export default __webpack_public_path__ + "static/media/icon-filled-cross-dark.e535d7f5e56945f995e942d8d2164eef.svg";
export { ForwardRef as ReactComponent };